'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface ActionButtonsProps {
  petName: string;
  onScheduleVisit: () => void;
  onStartAdoption: () => void;
  onShare: () => void;
}

const ActionButtons = ({
  petName,
  onScheduleVisit,
  onStartAdoption,
  onShare,
}: ActionButtonsProps) => {
  const [isFavorited, setIsFavorited] = useState(false);
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleFavoriteToggle = () => {
    if (!isHydrated) return;
    setIsFavorited(!isFavorited);
  };

  if (!isHydrated) {
    return (
      <div className="sticky top-20 space-y-4">
        <button
          disabled
          className="w-full px-6 py-4 bg-brand-cta text-white font-headline font-semibold rounded-xl opacity-50 cursor-not-allowed"
        >
          Start Adoption Process
        </button>
        <button
          disabled
          className="w-full px-6 py-4 bg-primary text-primary-foreground font-body font-medium rounded-xl opacity-50 cursor-not-allowed"
        >
          Schedule a Visit
        </button>
        <div className="grid grid-cols-2 gap-4">
          <button
            disabled
            className="px-6 py-3 bg-card border border-border rounded-xl opacity-50 cursor-not-allowed"
          >
            <Icon name="HeartIcon" size={24} variant="outline" />
          </button>
          <button
            disabled
            className="px-6 py-3 bg-card border border-border rounded-xl opacity-50 cursor-not-allowed"
          >
            <Icon name="ShareIcon" size={24} variant="outline" />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="sticky top-20 space-y-4">
      <button
        onClick={onStartAdoption}
        className="w-full px-6 py-4 bg-brand-cta text-white font-headline font-semibold rounded-xl hover:shadow-elevated hover:-translate-y-0.5 transition-all duration-300"
      >
        Start Adoption Process
      </button>

      <button
        onClick={onScheduleVisit}
        className="w-full px-6 py-4 bg-primary text-primary-foreground font-body font-medium rounded-xl hover:shadow-elevated hover:-translate-y-0.5 transition-all duration-300"
      >
        Schedule a Visit
      </button>

      <div className="grid grid-cols-2 gap-4">
        <button
          onClick={handleFavoriteToggle}
          className="flex items-center justify-center gap-2 px-6 py-3 bg-card border border-border rounded-xl hover:bg-muted transition-colors"
          aria-label={isFavorited ? 'Remove from favorites' : 'Add to favorites'}
        >
          <Icon
            name="HeartIcon"
            size={24}
            variant={isFavorited ? 'solid' : 'outline'}
            className={isFavorited ? 'text-error' : 'text-foreground'}
          />
          <span className="font-body text-sm text-foreground">
            {isFavorited ? 'Saved' : 'Save'}
          </span>
        </button>

        <button
          onClick={onShare}
          className="flex items-center justify-center gap-2 px-6 py-3 bg-card border border-border rounded-xl hover:bg-muted transition-colors"
          aria-label="Share pet profile"
        >
          <Icon name="ShareIcon" size={24} variant="outline" className="text-foreground" />
          <span className="font-body text-sm text-foreground">Share</span>
        </button>
      </div>

      <div className="p-4 bg-success/10 rounded-xl border border-success/20">
        <div className="flex items-start gap-3">
          <Icon name="InformationCircleIcon" size={20} variant="solid" className="text-success mt-0.5" />
          <div>
            <p className="text-sm font-body font-medium text-foreground mb-1">
              Meet {petName} Today!
            </p>
            <p className="text-xs text-muted-foreground font-body">
              Schedule a visit to see if you&apos;re the perfect match
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActionButtons;